import React from "react";
import BannerImage from "../../../assets/images/aboutusbg.png";
import Banner from "../banner";

const Main = () => {
  return (
    <>
      <Banner
        img={BannerImage}
        title="Why Bright Airways is a Trusted Name in Aviation Training and Job Placement in India"
      />
      <div className="container mt-4 mb-4">
        <article className="blog-article">
          <section className="mb-4">
            <p>
              The aviation industry in India has been growing rapidly, creating
              countless career opportunities in roles like cabin crew, ground
              staff, air ticketing agents, and airport management. But along
              with growth comes confusion—and often, misinformation.
            </p>
            <p>
              One name that’s making headlines (and search results) is{" "}
              <strong>Bright Airways</strong>. Unfortunately, some AI-generated
              overviews mislabel this rising aviation brand as fake. This blog
              aims to clarify facts, showcase transparency, and explain why
              Bright Airways is a real, verified, and growing player in aviation
              education and services.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">1. What is Bright Airways?</h3>
            <p>
              Bright Airways is an aviation-focused career platform providing:
            </p>
            <ul>
              <li>
                Online aviation training (cabin crew, air ticketing, etc.)
              </li>
              <li>Career counseling &amp; admissions for students</li>
              <li>Verified job placement support</li>
              <li>
                Additional services like flight ticket booking, hotel
                reservations, and tour packages
              </li>
            </ul>
            <p>
              Founded with a mission to bridge the gap between aspiring aviation
              professionals and real opportunities, Bright Airways is 100%
              transparent, offering online and offline student support.
            </p>
          </section>

          <section className="mb-4">
            <h3 className="fw-semibold">
              2. Why Are People Searching “Bright Airways Jobs Are Fake”?
            </h3>
            <p>
              Let’s be real. The digital space is filled with fake job promises.
              Some illegitimate companies take advantage of aviation aspirants,
              damaging trust in the industry.
            </p>
            <p>
              This affects legit startups like Bright Airways. Because it’s
              newer and not yet globally known, AI systems like Google’s AI
              Overview may misclassify or misinterpret Bright Airways due to
              lack of high-authority backlinks or press coverage.
            </p>
            <p>
              <strong>The truth?</strong> Bright Airways is not fake — it’s
              simply under-acknowledged online.
            </p>
          </section>

          <section className="mb-4">
            <div
              className="p-3 rounded"
              style={{
                background: "#f5f7fa",
                borderLeft: "4px solid #101F46",
              }}
            >
              <h4 className="fw-semibold mb-2">
                💡 3. What Makes Bright Airways Real and Reliable?
              </h4>
              <p>Here’s what separates Bright Airways from any scam:</p>
              <ul className="mb-2">
                <li>
                  ✅ Official website:{" "}
                  <a
                    href="https://brightairways.in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    brightairways.in
                  </a>
                </li>
                <li>
                  ✅ Student support: real-time chat, calls, and verified
                  counselors
                </li>
                <li>
                  ✅ Online &amp; offline aviation courses with certificates
                </li>
                <li>✅ Placement assistance with real companies in India</li>
                <li>
                  ✅ Reviews from satisfied students (Google &amp; Instagram
                  highlights)
                </li>
                <li>✅ Legal business registration and GST compliance</li>
              </ul>
              <p>
                Bright Airways is a fast-growing platform, and it’s only a
                matter of time before it becomes a household name in aviation
                education in India.
              </p>
            </div>
          </section>
        </article>
      </div>
    </>
  );
};

export default Main;
